import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Package, ShoppingBag, MessageSquare, Euro, Clock, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatCard = ({ icon: Icon, label, value, color, testid }) => (
  <div
    data-testid={testid}
    className="bg-white rounded-lg border border-gray-200 p-6 flex items-start gap-4 hover:shadow-md transition-shadow"
  >
    <div className={`p-3 rounded-lg ${color}`}>
      <Icon className="w-6 h-6 text-white" />
    </div>
    <div>
      <div className="text-3xl font-bold text-gray-900">{value}</div>
      <div className="text-sm text-gray-500 mt-1">{label}</div>
    </div>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/admin/stats`)
      .then((r) => setStats(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Tableau de bord</h1>
        <p className="text-gray-500 mt-1">Vue d'ensemble de votre activité</p>
      </div>

      {loading ? (
        <div className="text-gray-500">Chargement des statistiques...</div>
      ) : (
        <div data-testid="admin-stats-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <StatCard
            testid="stat-revenue"
            icon={Euro}
            label="Chiffre d'affaires (payé)"
            value={`${(stats?.total_revenue || 0).toFixed(2)} €`}
            color="bg-green-600"
          />
          <StatCard
            testid="stat-paid-orders"
            icon={CheckCircle}
            label="Commandes payées"
            value={stats?.paid_orders ?? 0}
            color="bg-blue-600"
          />
          <StatCard
            testid="stat-pending-orders"
            icon={Clock}
            label="Commandes en attente"
            value={stats?.pending_orders ?? 0}
            color="bg-amber-500"
          />
          <StatCard
            testid="stat-total-orders"
            icon={ShoppingBag}
            label="Total commandes"
            value={stats?.total_orders ?? 0}
            color="bg-[#E42313]"
          />
          <StatCard
            testid="stat-products"
            icon={Package}
            label="Produits au catalogue"
            value={stats?.total_products ?? 0}
            color="bg-gray-800"
          />
          <StatCard
            testid="stat-new-messages"
            icon={MessageSquare}
            label="Messages non lus"
            value={stats?.new_messages ?? 0}
            color="bg-purple-600"
          />
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
